/*
 * ******************************************************************
 * Copyright (c) 2020-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Directive } from "@angular/core";
import { RouterLinkActive } from "@angular/router";

// @formatter:off
@Directive({
    standalone: false,
    selector: "[dr-set-aria-current]",
    host: { "[attr.aria-current]": 'routerLinkActive.isActive ? "page" : null' }
})
// @formatter:on
export class DrSetAriaCurrentDirective {
    constructor(public routerLinkActive: RouterLinkActive) {
    }
}
